module.exports = __webpack_public_path__ + "img/default_p.4c0c7ef3.png";